import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, lifecycle, branch, renderComponent, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import { getUserProgramsFullRequest, selectUserPrograms, resetUserPrograms } from '../redux/reducers/userProgramsFull';
import { changeRedirectFlag } from '../redux/reducers/userOverallReport';
import { toggleThinkToolPopup, toggleUserDashboard, toggleAddProgrammePopup, toggleSaveEditPopup, toggleRefererPage } from '../redux/reducers/view';
import { announcementsRequest } from '../redux/reducers/announcements';
import Typography from '@material-ui/core/Typography';
import { getTeamMembersFullRequest, selectMessage,resetSelectionMessage } from '../redux/reducers/teamMembersFull';

import Spinner from './Spinner';
import Modal from '@material-ui/core/Modal';
import ProgrammesCard from './ProgrammesCard';
import { commonStyles, COLORS } from '../styles/styles';
import AlertAnnouncement from '../assets/alertAnnouncement.svg'
import SystemAnnouncement from '../assets/systemAnnouncement.svg'

import { convertTime } from '../utils';
import { updateMessageStatusRequest, messageStatusAction } from '../redux/reducers/message';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import { getUserModules, selectedProgram, getUserPrograms, getCompletedPrograms, getCurrentPrograms } from '../redux/selectors';

import { authAdminRequest, authUserRequest, getTokenFromCookies, logoutUserRequest } from '../redux/reducers/login';



import AvatarCirce from './AvatarCircle';

import { MDBCard, 
  MDBCardBody, 
  MDBCardTitle, 
  MDBCardText, 
  MDBCardHeader, 
  MDBBtn, 
  MDBContainer, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBRow,
  MDBCol,
  MDBIcon} from "mdbreact";
import { addProgramFailure } from '../redux/reducers/addProjectCode';
import authHOC from './AuthHOC';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import { assessmentsListRequest, toolsListRequest } from '../redux/reducers/contentList';
import { dropdownsRequest } from '../redux/reducers/dropdowns';





const LearnerProgrammesChoice = ({
  classes, 
  userProgramsFull, 
  onProgramClick, 
  showAlert, 
  handleOk, 
  handleAlert, 
  newAnnouncements, 
  handleMessageUpdate,
  completedPrograms,
  showLoader,
  loginReducer,
  toggleActiveTab,
  handleBack,
  programs,
  activeItem,
  toggleAddProgrammePopup
}) => {
  const renderPrograms = () =>
    programs &&
    programs.map(item => (
      <div className="col-md-6 col-lg-3" style={{width:'100%', paddingLeft:5, paddingRight:5}} key={item.programId} onClick={() => onProgramClick(item)} >

        <ProgrammesCard
         type="programCard"
         name={item.name}
         backgroundImg={item.background}
         description={item.description}
         background={item.background}
         startDate={
           item.startDate && item.startDate !== null ? convertTime(item.startDate.date) : ''
         }
         dueDate={item.dueDate && item.dueDate !== null ? convertTime(item.dueDate.date) : ''}
         isSelected={userProgramsFull.selectedProgramId === item.programId}
         status={item.status}
         rolloutCode ={item.rolloutCode}
        />
      </div>
    ));
    const renderCompletedPrograms = () =>
  
    completedPrograms &&
    completedPrograms.map(item => (
      <div className="col-md-6 col-lg-3" style={{width:'100%', paddingLeft:5, paddingRight:5}} key={item.programId} onClick={() => onProgramClick(item)} >
         <ProgrammesCard
          type="programCard"
          name={item.name}
          backgroundImg={item.background}
          description={item.description}
          background={item.background}
          rolloutCode={item.rolloutCode}
          startDate={
            item.startDate && item.startDate !== null ? convertTime(item.startDate.date) : ''
          }
          dueDate={item.dueDate && item.dueDate !== null ? convertTime(item.dueDate.date) : ''}
          isSelected={false}
          status={item.status}
        />
      </div>
    ));
  return <MDBContainer className=""><MDBCard  className="z-depth-2 rounded-0 yellow-card" style={{height:"100%"}}>

      <div className='text-dark text-left pt-3 pl-3'>
            CHOOSE A PROGRAM
            </div>
     <MDBBtn
            floating
          
            tag='a'
            className='ml-auto ml-4  d-md-none'
            action
            style={{position: 'absolute', right: 0}} 
            onClick={()=>toggleAddProgrammePopup(true)}
          >
            <MDBIcon icon='plus' className="success-color" size="md"/>
          </MDBBtn>
        

      <div className="classic-tabs">
        <MDBNav classicTabs className="pt-2 mt-3" style={{backgroundColor:'#EBEBEB'}}  >
          <MDBNavItem>
            <MDBNavLink link to="#" active={activeItem==="1"} onClick={() => toggleActiveTab("1")}>
              CURRENT PROGRAMS
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={activeItem==='2'} onClick={() => toggleActiveTab("2")}>
             COMPLETED PROGRAMS
            </MDBNavLink>
          </MDBNavItem>
        </MDBNav>
        <MDBTabContent activeItem={activeItem} className="contentScrollProg">
          <MDBTabPane tabId="1">
            <MDBRow>{renderPrograms()}</MDBRow>
          </MDBTabPane>
          <MDBTabPane tabId="2">
          <MDBRow>{  completedPrograms && renderCompletedPrograms()}</MDBRow> 
          </MDBTabPane>
        </MDBTabContent>
   </div>
    
    
  </MDBCard>
  </MDBContainer>
  
};

const styles = () => ({
  ...commonStyles,
  menuItem: {
    margin: '-8px 0',
  },
});


const mapStateToProps = state => ({
  view: state.viewReducer,
  loginReducer: state.loginReducer,
  userProgramsFull: state.userProgramsFullReducer,
  userOverallReportReducer: state.userOverallReportReducer,
  announcements: state.announcementsReducer.announcements,
  announcementApi: state.announcementsReducer,
  messageReducer: state.messageReducer,
  getProgram: selectedProgram(state),
  programs: getCurrentPrograms(state),
  userProgramsFull: state.userProgramsFullReducer,
  completedPrograms: getCompletedPrograms(state),
});

const mapDispatchToProps = dispatch => ({
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  toggleThinkToolPopup: value => dispatch(toggleThinkToolPopup(value)),
  changeRedirectFlag: value => dispatch(changeRedirectFlag(value)),
  announcementsRequest: () => dispatch(announcementsRequest()),
  messageStatusAction: value => dispatch(messageStatusAction(value)),
  selectMessage: messageId => dispatch(selectMessage(messageId)),
  resetSelectionMessage: () => dispatch(resetSelectionMessage()),
  updateMessageStatusRequest: value => dispatch(updateMessageStatusRequest(value)),
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
  resetUserPrograms: () => dispatch(resetUserPrograms()),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  toggleRefererPage: value => dispatch(toggleRefererPage(value)),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  toolListRequest: () => dispatch(toolsListRequest()),
  assessmentsListRequest: () => dispatch(assessmentsListRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
});

export default compose(
  withRouter,
  
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  
  withState('initialSelectionProgramm', 'handleInitialSelectionProgramm', false),
  withState('showAlert', 'toggleShowAlert', false),
  withState('showLoader', 'toggleShowLoader', false),
  withState('newAnnouncements','setAnnouncements', []),
  withState('activeItem','setActiveItem', '1'),
  withHandlers({
    handleMessageUpdate: props => (messageId) => {
      props.resetSelectionMessage();
      props.selectMessage(messageId)
      props.messageStatusAction('read');
      props.updateMessageStatusRequest(messageId)
    },

    handleBack: props => () => {
      props.history.push('/home' + props.history.location.search)
    },
  }),
  withHandlers({
    onProgramClick: props => item => {
     if(props.match.path=='/choosetool'){
      props.changeRedirectFlag(false);
      
      props.selectUserPrograms(item.programId);
      props.toolListRequest();
      props.history.push('/tools/'+item.programId+ props.history.location.search)
     }
     if(props.match.path=='/chooseassessment'){
       props.changeRedirectFlag(false);

       props.selectUserPrograms(item.programId);
       //props.assessmentsListRequest();
       props.history.push('/assessments/'+item.programId+ props.history.location.search)
     }

     if(props.match.path=='/choosesession'){
      props.changeRedirectFlag(false);
      
      props.selectUserPrograms(item.programId);
      props.history.push('/sessions/'+item.programId+ props.history.location.search)
     }
     if(props.match.path=='/programs'){
      props.changeRedirectFlag(false);
      
      props.selectUserPrograms(item.programId);
      props.history.push('/modules/'+item.programId+ props.history.location.search)
     }
    
      if (props.view.isUserDashboardOpened) {
        props.toggleUserDashboard(false);
      }
    },
    handleAlert: props => () => {
      const { showAlert } = props;
      props.toggleShowAlert(!showAlert);
    },
    toggleActiveTab: props => (tab) => {
      
      if (props.activeItem !== tab) {
        props.setActiveItem(tab)
      }
    },
   
    handleOk: props => () => {
      // const { showAlert } = props;
      // for (let index = 0; index < props.newAnnouncements.length; index++) {
      //   const element = props.newAnnouncements[index];
       
      
      //  setTimeout(() => (props.handleMessageUpdate(element.messageId)),index*500)
      // }
      // props.toggleShowAlert(!showAlert);
    }
  }),
  lifecycle({
    componentWillMount() {
      const { getUserProgramsFullRequest, announcementsRequest, resetUserPrograms, getProgram } = this.props;
      // getUserProgramsFullRequest();
      // announcementsRequest();
      // 
      // resetUserPrograms();
      
      if(getProgram){
        if(this.props.match.path=='/choosetool'){
          this.props.toggleSaveEditPopup(false);
          this.props.history.push('/tools/'+getProgram.programId+ this.props.history.location.search)
        }else if(this.props.match.path=='/chooseassessment'){
          this.props.toggleSaveEditPopup(false);
          this.props.history.push('/assessments/'+getProgram.programId+ this.props.history.location.search)
        }else{
          this.props.toggleSaveEditPopup(false);
          this.props.history.push('/sessions/'+getProgram.programId+ this.props.history.location.search)
        }
       
      }else{
        // getUserProgramsFullRequest();
        // announcementsRequest();
        // 
        // // resetUserPrograms();
      }
    },
    componentWillReceiveProps(nextProps) {
      if(nextProps.announcements!=this.props.announcements){
        var ann=[]
        for (let index = 0; index < nextProps.announcements.length; index++) {
          const element = nextProps.announcements[index];
          if(element.status=='new'){
            ann.push(element)
          }
          
        }
        nextProps.setAnnouncements(ann);
        if(ann.length>0){
          nextProps.toggleShowAlert(true);
        }else{
          nextProps.toggleShowAlert(false);
        }
      }
    },
    componentWillUnmount() {
      this.props.toggleThinkToolPopup(false);
    },
  }),
 
  withStyles(styles),
)(LearnerProgrammesChoice);

LearnerProgrammesChoice.propTypes = {
  userProgramsFull: PropTypes.instanceOf(Object),
  onProgramClick: PropTypes.func,
};
